import config from 'garaje/config/environment';

/**
 * Normalize an absolute JSON:API relationship link for the local dev proxy.
 *
 * In proxyMode (local dev against staging), the backend echoes its own Host into
 * absolute relationship links (e.g. https://app.envoy.christmas/api/v3/invites/:id/
 * platform-jobs). Ember Data follows absolute links verbatim, so from the
 * dashboard.envoy.dev page that follow is cross-origin -> CORS. It also lacks the
 * `a/visitors/` gateway prefix the proxy routes on. Rewrite the staging host to the
 * local proxy host and add the prefix so the follow stays same-origin and routable.
 *
 * No-op outside proxyMode (config.proxyMode is only set in development.js), so this
 * never changes production/staging/EU behavior.
 */
export default function rewriteProxyRelationshipLink(url) {
  if (!config.proxyMode || !config.apiOverwrittenHost) return url;

  const proxyHost = new URL(config.apiOverwrittenHost).host;
  let rewritten = url.replace(/\/\/app\.envoy\.[a-z.]+/i, `//${proxyHost}`);

  if (!rewritten.includes('/a/visitors/api/v')) {
    rewritten = rewritten.replace(/\/(api\/v\d+)\//, '/a/visitors/$1/');
  }

  return rewritten;
}
